const BLOCKED_DOMAINS = [
  // Search engines
  "google.com",
  "bing.com",
  "duckduckgo.com",
  "yandex.com",

  // Social media
  "facebook.com",
  "instagram.com",
  "twitter.com",
  "x.com",
  "linkedin.com",
  "tiktok.com",
  "reddit.com",

  // Video / streaming
  "youtube.com",
  "vimeo.com",
  "twitch.tv",

  // Email providers
  "gmail.com",
  "yahoo.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "proton.me",
  "protonmail.com",

  // Messaging
  "whatsapp.com",
  "telegram.org",
  "discord.com",
  "signal.org"
];

function normalizeUrl(input:string) {
  return input.startsWith("http")
    ? input
    : `https://${input}`;
}

export default function isBlockedDomain(input: string) {
  try {
    const normalized = normalizeUrl(input);
    const url = new URL(normalized);

    const hostname = url.hostname
      .toLowerCase()
      .replace(/^www\./, "");

    return BLOCKED_DOMAINS.some(domain =>
      hostname === domain || hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
}
